import { Box, ButtonBase, Grid, Hidden, LinearProgress, Link, Stack, styled, TextField, Typography } from "@mui/material";
import FlexRowAlign from "../../components/flexbox/FlexRowAlign";
import Countdown from "react-countdown";
import Iconify from "../../components/Iconify";
import { memo, useCallback, useState } from "react";
import FlexBetween from "../../components/flexbox/FlexBetween";
import { NumberInput } from "../../components/NumberInput";
import { LoadingButton } from "@mui/lab";
import useUserData from "../../hooks/useUserData";
import { fCurrency } from "../../utils/format";
import useAxios from "../../hooks/useAxios";
import { useTonAddress, useTonConnectModal, useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import toast from "react-hot-toast";
import { beginCell } from "@ton/core";
import Decimal from "decimal.js";
import useWalletBalance from "../../hooks/useWalletBalance";


export default function PreSale() {
    const { userData } = useUserData()
    const { tonBalance } = useWalletBalance()
    const { callApi } = useAxios()
    const { open: openWallet } = useTonConnectModal()
    const [isLoading, setIsLoading] = useState(false)
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const [amount, setAmount] = useState(0)

    const { open: openConnectWallet } = useTonConnectModal()
    const walletAddress = useTonAddress(true);
    const percen = new Decimal(userData?.totalPresale ?? 0).div(15000).div(100).greaterThanOrEqualTo(100) ? 100 : new Decimal(userData?.totalPresale ?? 0).div(15000).div(100).toDecimalPlaces(2, Decimal.ROUND_UP).toNumber()

    const handleSendTon = useCallback(async () => {
        setIsLoading(true);
        try {
            if (!userData?.user?.id) {
                setIsLoading(false);
                toast.error("Please login Telegram", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return
            }
            const body = beginCell()
                .storeUint(0, 32) // write 32 zero bits to indicate that a text comment will follow
                .storeStringTail(`WEB,PRESALE,${userData?.user?.id}`) // write our text comment
                .endCell();
            const defaultTx = {
                // The transaction is valid for 10 minutes from now, in unix epoch seconds.
                validUntil: Math.floor(Date.now() / 1000) + 600,
                messages: [
                    {
                        // The receiver's address.
                        address: "UQAGvVzwt9QNM8_oiTf0TGYFkwZORMCd4h5fHJfaWBpgv9w8",
                        // Amount to send in nanoTON. For example, 0.005 TON is 5000000 nanoTON.
                        amount: new Decimal(amount).mul(Decimal.pow(10, 9)).toString(),
                        payload: body.toBoc().toString("base64"),
                    },
                ],
            };
            await tonConnectUI.sendTransaction(defaultTx, {
                notifications: "success",
            });
            toast.success(
                "Your transaction will record soon.",
                {
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                },
            );
        } catch (error) {
            if (error.response && error.response.status === 400) {
                toast.error(`Error: ${error.response.data.message}`, {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("You rejected the transaction confirmation.", {
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } finally {
            setIsLoading(false);
        }
    }, [userData?.user?.id, tonConnectUI, amount]);

    const handleOpen = useCallback(() => {
        if (!wallet?.account) {
            openConnectWallet()
        } else {
            handleSendTon();
        }
    }, [handleSendTon, openConnectWallet, wallet?.account])
    return <Grid pt={{ xs: 17, md: 0 }} pb={{ xs: 7, md: 0 }} direction={'column'} container sx={{ background: 'url("/images/trailer-bg.png") no-repeat 50% 0%', backgroundSize: 'cover', borderRadius: { xs: 0, md: '2rem' }, flexDirection: { xs: 'column-reverse', md: 'row' } }}>
        <Grid item xs={12} md={7} pt={3}>
            <Box p={{ xs: 1, md: 8 }} sx={{
                position: 'relative',
            }}>
                <CustomBox sx={{ borderRadius: ['1rem 1rem 0px 0px', '0.75rem 0.75rem 0px 0px'], width: 'fit-content', margin: 'auto', position: 'relative', zIndex: 1 }}>
                    <Typography px={2} py={1} variant="h5">TRAILER</Typography>
                </CustomBox>
                <CustomBox sx={{ borderRadius: ['1.5rem', '1.25rem'], mt: "-10px", position: 'relative', zIndex: 2 }}>
                    <Box sx={{ pt: { xs: '0.5rem', md: '2rem' }, px: { xs: '0.5rem', md: '2rem' } }}>
                        <video src="/videos/trailer.mp4" playsInline loop muted autoPlay style={{ width: '100%', borderRadius: '0.5rem' }} />
                    </Box>
                    <FlexRowAlign gap={1} sx={{ mb: '-25px' }}>
                        <ButtonBase onClick={() => {
                            window.open("https://x.com/DefendersFury", "_blank", "noopener,noreferrer");
                        }} sx={{ height: 45, width: 165, background: 'url("/images/button-2.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
                            <Typography width={170}>X (TWITTER)</Typography>
                        </ButtonBase>
                        <ButtonBase onClick={() => {
                            window.open("https://t.me/DefendersFuryChannel", "_blank", "noopener,noreferrer");
                        }} sx={{ height: 45, width: 165, background: 'url("/images/button-1.png") no-repeat 50% 50%', backgroundSize: 'contain' }}>
                            <Typography width={170}>TELEGRAM</Typography>
                        </ButtonBase>
                    </FlexRowAlign>
                </CustomBox>
                <img src='/images/trailer-bg-1.png' className="trailer-bg-1" style={{ position: 'absolute', width: '70%', top: 0, left: '50%', translate: '-50% 0px', zIndex: 0 }} />
                <img src='/images/trailer-bg-2.png' style={{ position: 'absolute', width: '85%', bottom: 0, left: '50%', translate: '-45% -20%', zIndex: 0 }} />
                <Hidden mdDown>
                    <img src='/images/char-1.png' style={{ position: 'absolute', width: '200px', bottom: 0, left: '0%', translate: '10px -30px', zIndex: 2 }} />
                    <img src='/images/char-2.png' style={{ position: 'absolute', width: '200px', top: 0, right: '0%', translate: '-10px 40px', zIndex: 2 }} />
                </Hidden>
            </Box>
        </Grid>
        <Grid item xs={5}>
            <Box p={{ xs: 1, md: 8 }} pl={0} sx={{ position: 'relative' }}>
                <CustomBox background='#302E28' sx={{ borderRadius: ['1.5rem', '1.25rem'] }}>
                    <Box p={1} px={{ xs: 2, md: 4 }} textAlign={'center'}>
                        <FlexRowAlign gap={1} sx={{ color: '#FFF480' }}>
                            <Typography>COMING SOON</Typography>
                        </FlexRowAlign>
                        <Typography my={2} textAlign={'center'} variant="h4" sx={{ WebkitTextStrokeColor: '#581313', WebkitTextStrokeWidth: '8px' }}>DEFENDERS FURY PRESALES</Typography>
                        <Box sx={{ background: '#000', p: 2, py: 1, borderRadius: '0.5rem', margin: 'auto' }}>
                            <Typography variant="body" >Get early access to the newest game on KAT ecosystem</Typography>
                        </Box>
                        <Box mt={2} sx={{ position: 'relative', borderRadius: '0.7rem', overflow: 'hidden' }}>
                            <img src='/images/trailer-bg-3.png' style={{
                                width: '100%',
                            }} />
                            <Box p={2} sx={{ width: '100%', position: 'absolute', bottom: 0, left: 0, background: 'linear-gradient(transparent,#000 80%)' }}>
                                <Typography sx={{ width: '100%', textAlign: 'left' }}>Soft cap: 15,000 TON</Typography>
                                <Box sx={{ border: '1px solid #2A2A2A', borderRadius: '0.5rem', background: "#000", position: 'relative' }}>
                                    <LinearProgress variant="determinate" value={percen} sx={{
                                        height: '25px', borderRadius: '0.5rem', background: "#000", border: '4px solid #000',
                                        '& .MuiLinearProgress-bar': {
                                            background: '#E76F04',
                                            zIndex: 0,
                                        }
                                    }} />
                                    <Typography variant="body" fontWeight={700} fontSize={'0.8rem'} sx={{ lineHeight: '25px', position: 'absolute', top: 0, left: 0, width: '100%', textAlign: 'center' }}>{fCurrency(userData?.totalPresale ?? 0, 2)} TON</Typography>
                                </Box>
                            </Box>
                        </Box>
                        <FlexBetween py={1}>
                            <Typography fontWeight={700} variant="body" fontSize={{ xs: '0.8rem', md: '1rem' }} maxWidth={'50%'} lineHeight={'1rem'} textAlign={'left'}>Enter an amount of TON you want to commit</Typography>
                            <Typography fontWeight={700} variant="body" fontSize={{ xs: '0.8rem', md: '1rem' }} whiteSpace={'nowrap'} sx={{ color: '#35D7F4' }} textAlign={'right'}>Available: {fCurrency(tonBalance?.balance ?? 0, 2)} TON</Typography>
                        </FlexBetween>
                        <NumberInput
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="0.0"
                            sx={{
                                width: '100%',
                                pb: 2
                            }}
                            InputProps={{
                                sx: {
                                    '& fieldset': {
                                        border: '1px solid #E77003 !important',
                                        borderRadius: '0.4rem'
                                    }
                                },
                                endAdornment: <ButtonBase>
                                    <Typography variant="body" fontWeight={900} sx={{ color: '#E76F04', WebkitTextStrokeWidth: 0 }}>MAX</Typography>
                                </ButtonBase>
                            }}
                        />
                        <Typography sx={{ background: '#000', width: '100%', p: 2, py: 1, borderRadius: '0.5rem', margin: 'auto', color: '#7AE21E' }}>Your commitment: {fCurrency(userData?.presale ?? 0)} TON</Typography>
                        <LoadingButton onClick={() => {
                            handleOpen()
                        }} fullWidth sx={{ my: 2, background: 'linear-gradient(90deg,#7BE11F,#7FBAFF)' }}>{!wallet ? "Connect Wallet" : "CONFIRM"}</LoadingButton>
                    </Box>
                </CustomBox>
                <img src='/images/char-3.png' style={{ position: 'absolute', width: '150px', bottom: 0, right: '50%', translate: '350px -30px', zIndex: 2 }} />
            </Box>
        </Grid>
    </Grid>
}

export const CustomBox = ({ children, sx, background = '#000' }) => {
    return <Box sx={{ background: "#fff380", border: '2px solid #000', p: '2px', ...sx, borderRadius: sx?.borderRadius[0] || sx?.borderRadius }}>
        <Box sx={{ background: background, border: '3px solid #E76F04', borderRadius: sx?.borderRadius[1] || sx?.borderRadius }}>
            {
                children
            }
        </Box>
    </Box>
}

const CustomCountDown = memo(({ handleTimeOut }) => {
    const countdownTime = 30000
    return <Typography variant="body" fontSize={'1.3rem'}>
        <Countdown
            date={Date.now() + countdownTime}
            onComplete={() => handleTimeOut ? handleTimeOut() : null}
            renderer={({ seconds, minutes, hours, days }) => `Time left: ${days} days ${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}
        />
    </Typography >
}, () => true)
